import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import {
    showSize, boolAndReducer, getTimeStamp, myAxios, MyFormData, mimeTypeMap,
    appTitle, getDriveFolderId
} from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import Form from "./form";
//--------------------------------------------------------------------------------------------
const title = "Newspaper";
export default function Newspaper({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const rootFolderId = getDriveFolderId("newspaperRoot");
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [pop, setPop] = useState("");
    const [curData, setData] = useState("");
    const [curFile, setFile] = useState({name: "", id: ""});
    const [userList, setUserList] = useState([]);
    const [isFolder, setIsFolder] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    const [renderSwith, setRenderSwitch] = useState(true);
    const [showLoading, setShowLoading] = useState(false);
    const addressArray = location.pathname.split("/");
    const curId = addressArray[2] || rootFolderId;
    const curAction = addressArray[addressArray.length - 1];

    const [parentFolder, setParentFolder] = useState([{name: title, id: rootFolderId}]);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const closeIt = () => {
        const curFolderId = parentFolder[parentFolder.length - 1].id;
        curFolderId !== rootFolderId?history.push(`/${title}/${curFolderId}`):history.push(`/${title}`);
        setIsFolder(true);
        setData("");
        setFile({name: "", id: ""});
    }
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        //-----------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("common/createNewspaper.php",  formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------------------------------
        setRenderSwitch(s => !s);
        //setShowLoader(false);
        // const id = res.data;
        // setUserList(userList.map(u => u.id === id?{...u, id}:u))
        // history.goBack();
        history.push(`/${title}`);
        setData("");
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const addressArray = location.pathname.split("/");
        const curId = addressArray[2] || rootFolderId;
        const curAction = addressArray[addressArray.length - 1];
        if(curAction === "Add") return;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("action", "Read");
            //---------------------------------------
            setShowLoading(true);
            const resCur = await myAxios("common/currentNewspaper.php", formData);
            if(!isMounted){
                setShowLoading(false);
                return;
            }
            if(!resCur){
                setShowLoading(false);
                return;
            }
            //---------------------------------------
            setPop(resCur.data);
            formData.append("folderId", curId);
            formData.append("rootFolderId", rootFolderId);
            //---------------------------------------
            const resFolder = await myAxios("common/readDocFolderNew.php", formData);
            setShowLoading(false);
            if(!isMounted) return;
            if(!resFolder) return;
            //---------------------------------------
            if(!isMounted) return;
            if(curId !== rootFolderId){
                resFolder.data[1].reverse();
                setParentFolder(resFolder.data[1]);
                setUserList(resFolder.data[0]);
                setIsFolder(resFolder.data[2]);
            }else{
                history.push(`/${title}`);
                setUserList(resFolder.data);
                setParentFolder([{name: title, id: rootFolderId}]);
            }
        }
        getData();
        return () => {isMounted = false}
    }, [renderSwith, location.pathname, history, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {title}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {user.newspaper === "yes"?<>
                <span className = "pointer" onClick = {e => curId?history.push(`/${title}/${curId}/Add`):history.push(`/${title}/Add`)}>
                    Add {title}
                </span>
                {curAction === "Add"?
                <Form 
                    setData = {setData}
                    curData = {curData}
                    setFile = {setFile}
                    curFile = {curFile}
                    parentFolder = {parentFolder}
                    closeIt = {closeIt}
                    handleSubmit = {handleSubmit}
                    rootFolderId = {rootFolderId}

                    keyword = {"Add"}
                />:null}
                <span className = "pointer" onClick = {async() => {
                    let folderName = window.prompt("Folder Name: ");
                    if(folderName === null) return;
                    while(folderName === ""){
                        window.alert("Folder Name can not be empty.");
                        folderName = window.prompt("Folder Name: ");
                        if(folderName === null) return;
                    }
                    const formData = new MyFormData();
                    formData.append("parentFolderId", curId);
                    formData.append("folderName", folderName);
                    //---------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("common/createFolder.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //---------------------------------------
                    setRenderSwitch(s => !s);
                }}>
                    Add Folder
                </span>
                </>
                :null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <>
                <div className = "m-3 font-weight-bold text-success">
                    Folder:&nbsp;
                    {parentFolder.map((f, fi) => 
                        <span 
                            key = {fi}
                            className = "pointer"
                            onClick = {() => {
                                if(!f.id) return;
                                if(f.id === rootFolderId){
                                    history.push(`/${title}`);
                                }else{
                                    history.push(`/${title}/${f.id}`);
                                }
                            }}
                        >
                            {f.name}
                        </span>
                    ).reduce((a, b) => [a, 
                    <span key = {b.key + "reduce"}>
                        &nbsp;&rarr;&nbsp;
                    </span>, b])}
                </div>
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Size</th>
                                {user.newspaper === "yes"?<><th></th><th></th></>:null}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.map((doc, key) =>
                            <tr key = {key} id = {doc.id} className = "pointer">
                                {doc.mimeType === mimeTypeMap.folder?
                                <>
                                <td><span className = "font-weight-bold" style = {{color: "blue"}} onClick = {() => {
                                    history.push(`/${title}/${doc.id}`);
                                }}>{doc.name}</span></td>
                                <td>Folder</td>
                                <td></td>
                                </>
                                :
                                <>
                                <td>{doc.name}{pop === doc.id?<span className = "ml-2 badge badge-primary">pop</span>:null}</td>
                                <td>Newpaper</td>
                                <td>{showSize(doc.size)}</td>
                                </>
                                }
                                <td>
                                    {user.newspaper === "yes" && doc.mimeType === mimeTypeMap.folder?
                                    <span className = "btn btn-info" onClick = {async() => {
                                        let fileName = window.prompt("Name:");
                                        if(fileName === null) return;
                                        while(fileName === ""){
                                            window.alert("The name cannot be empty.");
                                            fileName = window.prompt("Name:");
                                            if(fileName === null) return;
                                        }
                                        const formData = new MyFormData();
                                        formData.append("fileId", doc.id);
                                        formData.append("fileName", fileName);
                                        //---------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/renameFile.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //---------------------------------------
                                        setRenderSwitch(s => !s);
                                    }}>
                                        Rename
                                    </span>
                                    :null}
                                    {doc.mimeType !== mimeTypeMap.folder?
                                    <span className = "btn btn-info" onClick = {async() => {
                                        history.push(`/${title}/${doc.id}`);
                                    }}>
                                        {user.newspaper === "yes"?"Edit":"View"}
                                    </span>
                                    :null}
                                </td>
                                {curId === doc.id && !isFolder?
                                    <Form 
                                        setData = {setData}
                                        curData = {curData}
                                        setFile = {setFile}
                                        curFile = {curFile}
                                        parentFolder = {parentFolder}
                                        closeIt = {closeIt}
                                        handleSubmit = {handleSubmit}
                                        rootFolderId = {rootFolderId}

                                        keyword = {user.newspaper === "yes"?"Edit":"View"}
                                        
                                        curId = {curId}
                                        doc = {doc}
                                    />:null}
                                {user.newspaper === "yes"?
                                <>
                                <td><span className = "btn btn-danger" onClick = {async() => {
                                    if(!window.confirm("Are you sure to delete this document?")) return;
                                    const formData = new MyFormData();
                                    formData.append("fileId", doc.id);
                                    //---------------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("common/deleteFile.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //---------------------------------------
                                    setRenderSwitch(s => !s);
                                }}>Delete</span></td>
                                <td>
                                    {doc.mimeType !== mimeTypeMap.folder?
                                    <span className = {`btn btn-${pop !== doc.id?"success":"danger"}`} onClick = {async() => {
                                        if(!window.confirm("Are you sure to make this document current?")) return;
                                        const fileId = pop !== doc.id?doc.id:"";
                                        const formData = new MyFormData();
                                        formData.append("fileId", fileId);
                                        //---------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/currentNewspaper.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //---------------------------------------
                                        setPop(fileId);
                                        setRenderSwitch(s => !s);
                                    }}>
                                        {pop !== doc.id?"Set Pop":"Cancel Pop"}
                                    </span>
                                    :null}
                                </td>
                                </>
                                :null}
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                </>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}